

import InvoicedGoodsServices from "models/invoiced-goods-services";
export default {
  data() {
    return {
      invoicedGoodsServicesList: [],
      // 已开启开票商品或劳务名称列表
      openInvoicedGoodsServicesList: [],
    }
  },
  created() {
  },
  methods: {
    /** 
     * @description 开票商品或劳务名称列表
    */
    initInvoicedGoodsServicesList() {
      InvoicedGoodsServices.getInvoicedGoodsServicesList().then(res => {
        if (res.success) {
          let arr = [];
          let openInvoicedGoodsServicesList = [];
          res.result.map((value, index) => {
            let obj = {};
            obj.id = value.id;
            obj.sort = index + 1 < 10 ? `0${index + 1}` : index + 1;
            obj.status = value.status;
            obj.name = value.name;
            arr.push(obj);
            if (value.status) openInvoicedGoodsServicesList.push(obj)
          });
          this.invoicedGoodsServicesList = arr;
          this.openInvoicedGoodsServicesList = openInvoicedGoodsServicesList;
        }
      });
    },
  }
}